import { ClaimGroupMessages, TranslationClaimGroupMessages } from "../interfaces";

export const messages : TranslationClaimGroupMessages = {
  [ClaimGroupMessages.concreteBatchingPlant]: "Concrete Batching Plant",
  [ClaimGroupMessages.gravel]: "Gravel",
  [ClaimGroupMessages.supply]: "Supply",
  [ClaimGroupMessages.characteristic]: "Characteristic",
  [ClaimGroupMessages.classification]: "Classification",
  [ClaimGroupMessages.supplier]: "Supplier",
  [ClaimGroupMessages.concreteBatchingPlantGroup]: "Concrete Batching Plant Group",
  [ClaimGroupMessages.productGroup]: "Product Group",
  [ClaimGroupMessages.concreteRecipe]: "Product",
  [ClaimGroupMessages.concreteBatchingPlantRegional]: "Concrete Batching Plant Regional",
  [ClaimGroupMessages.slump]: "Slump",
  [ClaimGroupMessages.measureUnitType]: "Measure Unit Type",
  [ClaimGroupMessages.technicalDataSupply]: "Technical Data",
  [ClaimGroupMessages.costSupply]: "Cost",
  [ClaimGroupMessages.abramsCurve]: "Abrams Curve",
  [ClaimGroupMessages.concreteRecipeFamily]: "Concrete Recipe Family",
  [ClaimGroupMessages.copyInBatch]: "Copy In Batch",
  [ClaimGroupMessages.changeInBatch]: "Change In Batch",
  [ClaimGroupMessages.userRightsControl]: "User Rights Control",
  [ClaimGroupMessages.externalId]: "External Id",
  [ClaimGroupMessages.csvImport]: "Csv Import",
  [ClaimGroupMessages.concreteMixDesignSheet]: "Concrete Mix Design Sheet",
  [ClaimGroupMessages.concreteMixDesignSheetParameters]: "Concrete Mix Design Sheet Parameters",
  [ClaimGroupMessages.aggregateTest]: "Aggregate Test",
  [ClaimGroupMessages.aggregateTestReport]: "Aggregate Test Report",
  [ClaimGroupMessages.sieve]: "Sieve",
  [ClaimGroupMessages.responsibleEngineer]: "Responsible Engineer",
  [ClaimGroupMessages.laboratory]: "Laboratory",
  [ClaimGroupMessages.laboratoryTechnician]: "Laboratory Technician",
  [ClaimGroupMessages.standard]: "Standards",
  [ClaimGroupMessages.integrations]: "Integrations",
  [ClaimGroupMessages.vehicles]: "Vehicles",
  [ClaimGroupMessages.employees]: "Employees",
  [ClaimGroupMessages.reports]: "Reports",
  [ClaimGroupMessages.generalParameters]: "General Parameters",
  [ClaimGroupMessages.expedition]: "Expedition",
  [ClaimGroupMessages.aggregateMoisture]: "Aggregate Moisture",
  [ClaimGroupMessages.loadTickets]: "Load Tickets",
  [ClaimGroupMessages.deliveriesTickets]: "Deliveries Tickets",
  [ClaimGroupMessages.loadReuse]: "Load Reuse",
  [ClaimGroupMessages.invoices]: "Invoices",
  [ClaimGroupMessages.weighingLink]: "Weighing Link",
  [ClaimGroupMessages.inventory]: "Inventory",
  [ClaimGroupMessages.inventoryClosure]: "Inventory Closure",
  [ClaimGroupMessages.dailyClosing]: "Daily Closing",
  [ClaimGroupMessages.invoiceStub]: "Invoice Stub",
  [ClaimGroupMessages.approvalOfAdditionalFees]: "Approval Of Additional Fees",
  [ClaimGroupMessages.schedulings]: "Schedulings",
  [ClaimGroupMessages.concreteBatchingPlantGroupDispatch]: "Concrete Batching Plant Group",
  [ClaimGroupMessages.concreteBatchingPlantRegionalDispatch]: "Concrete Batching Plant Regional",
  [ClaimGroupMessages.delivery]: "Delivery",
  [ClaimGroupMessages.reservation]: "Reservation",
  [ClaimGroupMessages.concreteBatchingPlantsDispatch]: "Concrete Batching Plants",
  [ClaimGroupMessages.concreteBatchingPlantGeneralParameters]: "Concrete Batching Plant General Parameters",
  [ClaimGroupMessages.concreteBatchingPlantOpeningHoursParameters]: "Concrete Batching Plant Opening Hours Parameters",
  [ClaimGroupMessages.concreteBatchingPlantAverageDurationParameters]: "Concrete Batching Plant Average Duration Parameters",
  [ClaimGroupMessages.concreteBatchingPlantMoldingParameters]: "Concrete Batching Plant Molding Parameters",
  [ClaimGroupMessages.concreteBatchingPlantDailyClosingParameters]: "Concrete Batching Plant Daily Closing Parameters",
  [ClaimGroupMessages.concreteBatchingPlantTaxDocumentParameters]: "Concrete Batching Plant Tax Document Parameters",
  [ClaimGroupMessages.loadingPoints]: "Loading Points",
  [ClaimGroupMessages.loadingPointLocations]: "Loading Point Locations",
  [ClaimGroupMessages.deliveryRoutes]: "Delivery Routes",
  [ClaimGroupMessages.pumpingTypes]: "Pumping Types",
  [ClaimGroupMessages.piecesToBeConcreted]: "Pieces To Be Concreted",
  [ClaimGroupMessages.defaultDurationsByPumpingType]: "Default Durations By Pumping Type",
  [ClaimGroupMessages.holidays]: "Holidays",
  [ClaimGroupMessages.reasons]: "Reasons",
  [ClaimGroupMessages.taxConfigurationConcreteRecipe]: "Tax Configuration Concrete Recipe",
  [ClaimGroupMessages.users]: "Users",
  [ClaimGroupMessages.groups]: "Groups",
  [ClaimGroupMessages.alerts]: "Alerts",
  [ClaimGroupMessages.concreteDiscardDestination]: "Discard destination",
  [ClaimGroupMessages.loadTicketBlockReason]: "Load ticket block reason",
  [ClaimGroupMessages.pumpingBlockReason]: "Pumping block reason",
  [ClaimGroupMessages.dailyProductionClosingInconsistencies]: "Daily production closing inconsistencies",
  [ClaimGroupMessages.batchMaintenanceView]: "Maintenance Task View",
  [ClaimGroupMessages.batchMaintenanceEdit]: "Maintenance Task Edit",
  [ClaimGroupMessages.batchMaintenanceExecute]: "Maintenance Task Execute",
  [ClaimGroupMessages.batchAutomationView]: "Automation View",
  [ClaimGroupMessages.batchAutomationExecute]: "Automation Execute",
  [ClaimGroupMessages.batchAutomationAdmin]: "Automation Admin",
  [ClaimGroupMessages.batchAutomationSuperAdmin]: "Automation Super Admin",
  [ClaimGroupMessages.timeRecords]: "Time Records Management",
  [ClaimGroupMessages.timeClockConfigurations]: "Time Clock Configuration",
  [ClaimGroupMessages.performance]: "Performance Indicators (KPIs)",
  [ClaimGroupMessages.laboratoryModule]: "Laboratory access",
  [ClaimGroupMessages.specimenCollection]: "Specimen collection",
  [ClaimGroupMessages.specimenRupture]: "Specimen rupture",
  [ClaimGroupMessages.deliveryTicketSpecimens]: "Shipments/samples panel",
  [ClaimGroupMessages.collectionSchedule]: "Collection schedule",
  [ClaimGroupMessages.ruptureSchedule]: "Rupture schedule",
  [ClaimGroupMessages.issueCertificate]: "Issue certificate",
  [ClaimGroupMessages.issuedCertificates]: "Issued certificates",
  [ClaimGroupMessages.presses]: "Presses",
  [ClaimGroupMessages.certificateParameters]: "Strength certificate parameters",
  [ClaimGroupMessages.laboratoryStatistics]: "Laboratory statistics",
  [ClaimGroupMessages.lowStrengthApproval]: "Low strength approval"
};
